var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.rootClass},[(_vm.isImage)?_c('Gallery',{attrs:{"images":_vm.images,"displacement":_vm.displacementImage},on:{"isReady":_vm.handleLoad}}):(_vm.isVideo)?_c('video',{class:`${_vm.rootClass}__video`,attrs:{"autoplay":"","muted":"","loop":"","src":_vm.video.url},domProps:{"muted":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }